import PropTypes from 'prop-types';

export const refPropType = PropTypes.oneOfType([
    PropTypes.func,
    // eslint-disable-next-line react/forbid-prop-types
    PropTypes.shape({ current: PropTypes.any }),
]);

export const logoPropType = PropTypes.exact({
    src: PropTypes.string,
    alt: PropTypes.oneOfType([
        PropTypes.string,
        // eslint-disable-next-line react/forbid-prop-types
        PropTypes.number,
    ]),
});

export const convincerPropType = PropTypes.exact({
    text: PropTypes.string,
    badge: PropTypes.shape({
        image: logoPropType,
        text: PropTypes.string,
    }),
    v2: PropTypes.shape({
        layout: PropTypes.string,
        svg: PropTypes.string,
        text: PropTypes.string,
    }),
});

export const employerLocationPropType = PropTypes.exact({
    city: PropTypes.string,
    state: PropTypes.string,
    country: PropTypes.string,
});

export const companyPropType = PropTypes.shape({
    companyName: PropTypes.string,
    companyId: PropTypes.number,
    logo: PropTypes.shape({
        src: PropTypes.string,
        alt: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    }),
    companyUrl: PropTypes.string,
    remoteUrl: PropTypes.string,
    careerUrl: PropTypes.string,
    rating: PropTypes.number,
    isSponsor: PropTypes.bool,
    reviewCount: PropTypes.number,
    isFollowed: PropTypes.bool,
    employerInfo: PropTypes.shape({
        banner: PropTypes.shape({
            src: PropTypes.string,
            alt: PropTypes.string,
        }),
        hq: PropTypes.shape({
            city: PropTypes.string,
            state: PropTypes.string,
            country: PropTypes.string,
        }),
        jobCount: PropTypes.number,
        companySize: PropTypes.string,
    }),
    industry: PropTypes.string,
    googleSeo: PropTypes.string,
    bannerText: PropTypes.string,
    version: PropTypes.number,
});

const verifiedBenefitPropType = PropTypes.exact({
    benefit_type: PropTypes.string,
    text: PropTypes.string,
});

export const verifiedBenefitsPropType = PropTypes.arrayOf(
    verifiedBenefitPropType
);
